import { TextField } from '@mui/material'
import { usePersonaStore } from '../../../../../store/usePersonaStore'

const Name = () => {
  const { name, setName } = usePersonaStore()

  return (
    <div className="flex flex-col p-[20px]">
      <span className="Headline3-22Bd">이 사람의 이름은 무엇인가요?</span>

      <TextField
        variant="standard"
        placeholder="이름"
        value={name}
        multiline
        sx={{
          mt: 3,
          '& .MuiInputBase-inputMultiline': {
            outline: 'none !important', // ✅ 진짜로 없애기
          },
          '& .Mui-focused .MuiInputBase-inputMultiline': {
            outline: 'none !important', // ✅ 포커스 중에도 없애기
          },
          '& .MuiInputBase-inputMultiline:focus': {
            outline: 'none',
            boxShadow: 'none',
          },
          '& .MuiInput-underline:after': {
            borderBottom: '2px solid #503CC8', // ✅ focus 시 밑줄
          },
        }}
        helperText="최대 8자"
        onChange={(e) => setName(e.target.value)}
      />
    </div>
  )
}
export default Name
